module.exports = __webpack_public_path__ + "fonts/fb73b17c1d3a10bdbad57fe97ee457d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/miller_logo.svg
// module id = 1926
// module chunks = 0